import React from "react";
import XGSFormSelect from "ui-components/form/select/xgsFormSelect";
import { LabelModes } from "ui-components/molecules/labeled-inputs/labeledInput";
import {
  useFormikContext,
} from 'formik';
import { AddEditAddress, locationTypeOptions, areaTypeOptions, facilityTypeOptions, subLocationTypeOptions } from "app/data/address-manager/models";

export default function LocationClassification({ isEdit }: { isEdit: boolean }) {
  const { values, setFieldValue } = useFormikContext<AddEditAddress>();

  return (
    <>
      <div className="grid-2col">
        <div className="grid-item">
          <XGSFormSelect
            label="Location Type (RDI)"
            name="locationType"
            isClearable
            required={true}
            options={locationTypeOptions.map((opt) => ({
              ...opt,
              isDisabled:
                (values.facilityType === "Medical Facility" && opt.value !== "Limited Access") ||
                (values.areaType === "Residential Zone" && opt.value === "Commercial") ||
                (values.areaType === "Commercial Zone" && opt.value === "Residential"),
            }))}
            value={values?.locationType ? locationTypeOptions.find(
              (option) => option.value === values.locationType
            ) : null}
            onValueChange={(option) => {
              setFieldValue("locationType", option?.value ?? "");
              setFieldValue("limitedAccess", option?.value === "Limited Access" ? true : values?.limitedAccess);
            }}
            formik
            labelMode={LabelModes.column}
          />
        </div>
        {values?.locationType === "Limited Access" && <div className="grid-item">
          <XGSFormSelect
            label="Access Type"
            name="limitedAccessSubtype"
            isClearable
            required={!isEdit || values?.locationType === "Limited Access"}
            options={subLocationTypeOptions}
            value={values?.limitedAccessSubtype ? subLocationTypeOptions.find(
              (option) => option.value === values.limitedAccessSubtype
            ) : null}
            onValueChange={(option) => {
              setFieldValue("limitedAccessSubtype", option?.value ?? "");
            }}
            formik
            labelMode={LabelModes.column}
          />
        </div>}
        <div className="grid-item">
          <XGSFormSelect
            label="Area Type"
            name="areaType"
            isClearable
            required={true}
            value={
              values?.areaType
                ? areaTypeOptions.find((option) => option.value === values.areaType)
                : null
            }
            onValueChange={(option) => {
              setFieldValue("areaType", option?.value ?? "");
            }}
            options={areaTypeOptions.map((opt) => ({
              ...opt,
              isDisabled:
                (values.locationType === "Commercial" && opt.value === "Residential Zone") ||
                (values.locationType === "Residential" && opt.value === "Commercial Zone"),
            }))}
            formik
            labelMode={LabelModes.column}
          />

        </div>
        <div className="grid-item">
          <XGSFormSelect
            label="Facility Type"
            name="facilityType"
            isClearable
            options={facilityTypeOptions}
            value={values?.facilityType ? facilityTypeOptions.find(
              (option) => option.value === values.facilityType
            ) : null}
            onValueChange={(option) => {
              setFieldValue("facilityType", option?.value ?? "");
            }}
            formik
            labelMode={LabelModes.column}
          />
        </div>
      </div>
    </>
  );
}
